"use client"

import { ComponentType, renderComponent } from '@/components/factory/ComponentFactory';
import React, { useEffect, useState } from 'react'
import { SEOComponent } from '../seo/SEO.component';
import { PageLayout } from '@/components/layout/PageLayout';
import { Spin } from 'antd';
import { getPage } from '@/services/pageService';
import { HOME_PAGE_SLUG } from '@/configs/commons';

const HomePage = () => {
    const [pageContent, setPageContent] = useState<Record<string, any> | null>(null);


    useEffect(() => {
        async function fetchHomePage() {
            try {
                const result = await getPage(HOME_PAGE_SLUG);
                if (!result || !result.components) {
                    throw new Error('Page has no data or missing components');
                }
                setPageContent(result);
            } catch (err) {
                console.error('Error loading homepage:', err);
            }
        }

        fetchHomePage();

        // Save UTM params to localStorage
        const utmKeys = ['utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term'];
        const params = new URLSearchParams(window.location.search);
        let found = false;

        utmKeys.forEach(key => {
            const value = params.get(key);
            if (value) {
                localStorage.setItem(key, value);
                found = true;
            }
        });

        // save the retention time
        if (found) {
            localStorage.setItem('utm_saved_at', Date.now().toString());
        }
    }, []);

    const renderComponents = (components: any[]) => {
        return components.map((comp, key) => {
            return (
                <div key={key}>
                    {renderComponent(comp['__component'] as ComponentType, comp)}
                </div>
            )
        });
    }

    if (!pageContent) {
        return (
            <div className="flex items-center justify-center min-h-screen w-full bg-[var(--black-primary-bg)]">
                <Spin size="large" />
            </div>
        )
    }

    return (
        <PageLayout pageContent={pageContent}>
            <SEOComponent {...pageContent} />
            {pageContent.components && renderComponents(pageContent.components)}
        </PageLayout>
    )
}

export default HomePage